import { DmpSexEnum } from "./dmp-hl-find-patient-params.interface";

export interface DmpHlFindPatientResponse {
  CivilStatus: DmpHlFindPatientResponseCivilStatus;
  Ins: DmpHlFindPatientResponseSIns;
  i_matchingPercentage: number;
  i_sex: DmpSexEnum;
  s_birthDay: Date;
  s_birthName: string;
  s_city: string;
  s_insC: string;
  s_postalCode: string;
  i_birthRank?: number;
}

export interface DmpHlFindPatientResponseCivilStatus {
  i_gender: FindPatientResponseGender;
  s_given: string;
  s_name: string;
}

export interface DmpHlFindPatientResponseSIns {
  s_ins: string;
  s_insType: 'D' | 'T' | 'N';
}

export enum FindPatientResponseGender {
  'Civilité inconnue',
  'Mr',
  'Mme'
}
